
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

const AdminLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const { accessToken } = await api.login(username, password);
      localStorage.setItem('accessToken', accessToken);
      navigate('/admin');
    } catch (error) {
      setError('Invalid username or password.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-[#264864] via-[#264864] to-[#35a89d] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 p-10 backdrop-blur-xl rounded-2xl border border-white/20 shadow-lg z-10">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-white">
            Admin Login
          </h2>
          <p className="mt-2 text-sm text-white/70">
            Sign in to your admin account
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="username" className="sr-only">Username</label>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                required
                className="bg-white/5 border border-white/15 text-white placeholder-white/70 focus:border-[#58afd1] focus:ring-[#58afd1] backdrop-blur-sm transition-all duration-300 py-2 px-3 rounded-t-md w-full text-sm"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">Password</label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="bg-white/5 border border-white/15 text-white placeholder-white/70 focus:border-[#58afd1] focus:ring-[#58afd1] backdrop-blur-sm transition-all duration-300 py-2 px-3 rounded-b-md w-full text-sm"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <p className="text-red-400 text-sm text-center">{error}</p>
          )}

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gradient-to-r from-[#58afd1] to-[#4a9bc4] hover:from-[#1e3650] hover:to-[#4a9bc4] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#58afd1]"
            >
              Sign in
            </button>
          </div>
        </form>
        <div className="text-sm text-center">
          <Link to="/" className="font-medium text-white/70 hover:text-white">
            Go back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;

